var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('TableApp', {
    ref: "links",
    attrs: {
      "titulo": "Cadastro de Links de pagamento",
      "acaoBtn": "/#/links/novo",
      "textoBtn": "Novo",
      "api-url": "/link/lista",
      "fields": _vm.fields,
      "classFilterColumn": "links",
      "perPage": 10
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'id_link' ? _c('span', {
          attrs: {
            "slot": "id_link"
          },
          slot: "id_link"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', [_c('a', {
          staticClass: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
        }, [_vm._v(_vm._s(props.rowData.id_link))])])])])]) : _vm._e(), props.field == 'descricao' ? _c('span', {
          attrs: {
            "slot": "descricao"
          },
          slot: "descricao"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', [_c('a', {
          staticClass: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
        }, [_vm._v(_vm._s(props.rowData.descricao))])])])])]) : _vm._e(), props.field == 'nome_destinatario' ? _c('span', {
          attrs: {
            "slot": "nome_destinatario"
          },
          slot: "nome_destinatario"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', [_c('a', {
          staticClass: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
        }, [_vm._v(_vm._s(props.rowData.nome_destinatario))])])])])]) : _vm._e(), props.field == 'valor' ? _c('span', {
          attrs: {
            "slot": "valor"
          },
          slot: "valor"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.valor, 2)) + " ")])]) : _vm._e(), props.field == 'data_expiracao' ? _c('span', {
          attrs: {
            "slot": "data_expiracao"
          },
          slot: "data_expiracao"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(props.rowData.data_expiracao, "DD/MM/YYYY HH:mm")) + " ")])]) : _vm._e(), props.field == 'data_pagamento' ? _c('span', {
          attrs: {
            "slot": "data_pagamento"
          },
          slot: "data_pagamento"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(props.rowData.data_pagamento, "DD/MM/YYYY HH:mm")) + " ")])]) : _vm._e(), props.field == 'vezes' ? _c('span', {
          attrs: {
            "slot": "vezes"
          },
          slot: "vezes"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.vezes) + " ")])]) : _vm._e(), props.field == 'status' ? _c('span', {
          attrs: {
            "slot": "status"
          },
          slot: "status"
        }, [props.rowData.status == 1 ? _c('span', {
          staticClass: "label label-lg label-inline label-light-primary"
        }, [_vm._v("Em Aberto")]) : _c('span', {
          staticClass: "label label-lg label-inline label-light-success"
        }, [_vm._v("Pago")])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "dropdown dropdown-inline"
        }, [props.rowData.status == 1 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Copiar Link',
            expression: "'Copiar Link'"
          }],
          staticClass: "btn btn-sm btn-success btn-hover-success btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.doCopy(props.rowData);
            }
          }
        }, [_c('Link', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e(), props.rowData.status == 1 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Excluir',
            expression: "'Excluir'"
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.excluir(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e()])])])]) : _vm._e()];
      }
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };